<script setup lang="ts">
	import { twMerge } from 'tailwind-merge'
	const { class: classes, ...attrs } = useAttrs()

	interface NavigationItem {
		label: string,
		name: string,
		slug?: string,
		title: string,
		filter?: string,
		children?: Array<NavigationItem>
	}

	export type {
		NavigationItem
	}

	const { items, isScrolled } = defineProps<{
		items: Array<NavigationItem>,
		isScrolled: boolean
	}>()
</script>

<template>
	<nav v-if="items?.length" role="navigation" :class="twMerge('my-auto inline-flex justify-center items-center h-full', classes)">
		<div class="flex flex-row justify-start space-x-6 lg:space-x-8 xl:space-x-12 2xl:space-x-16 h-full">
			<NavigationMainDropdownItem v-for="(item,idx) in items" :key="'nav-main-' + idx" :item="item" :isScrolled="isScrolled" />
		</div>
	</nav>
</template>
